/* eslint-disable no-implicit-globals*/
var productCtn = $('input[name=productCodePost]').val(),
    omnitureName = '',
    omnitureDescription = '';

/* eslint-enable no-implicit-globals*/
ACC.omniture = {

  bindTrackConversion: function(name, description) {
    if (window.gaObject) {
      window.eddlEvents = window.eddlEvents || [];

      var clickEventInfo = {
        triggerName: 'buttonClick',
        componentType: 'button',
        interaction: {
          goal: name,
          description: description,
          interactive: true
        }
      };
      var eddlAction = {};

      eddlAction = window.gaObject.interactionEvent(clickEventInfo);
      window.eddlEvents.push(eddlAction);
    }
  },

  updatePassword: function(txt) {
    if (txt === 'Positive') {
      omnitureName = 'interaction';
      omnitureDescription = 'link:update_password_submit';
    } else if (txt === 'Negative') {
      omnitureName = 'validation_error';
      omnitureDescription = 'password_validation_error';
    }

    ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
  },

  bindRegistrationPage: function() {
    $(document).on('click', '.ph-registration', function() {
      var ischecked = '',
          registrationName = 'user_registration';

      if ($('#ph-optinCheckbox').is(':checked')) {
        ischecked = 'selected';
      } else {
        ischecked = 'unselected';
      }

      if ($('.ph-salesrep').val() === 'true') {
        registrationName = 'customer_registration';
      }

      var desc = 'optin:' + ischecked;

      ACC.omniture.bindTrackConversion(registrationName, desc);
    });
  },
  bindLoginPage: function() {
    var informationMessage = document.getElementsByClassName('ph-information_message ');

    if ($('#updatePasswordForm').length > 0 && informationMessage.length > 0) {
      if (informationMessage[0].classList[1] === 'negative') {
        ACC.omniture.updatePassword('Negative');
      }
    }

    if ($('.ph-passtrack').length > 0 && $('.ph-passtrack').attr('data-passwordsuccess') === 'true') {
      if (informationMessage.length > 0 && informationMessage[0].classList[1] === 'ph-orangebutton') {
        ACC.omniture.updatePassword('Positive');
      }
    }

    if ($('.template-pages-LoginPageTemplate').length > 0 && location.search.split('=')[1] === 'true') {
      omnitureName = 'validation_error';
      omnitureDescription = 'Login credentials can\'t be found';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    }

    $(document).on('click', '.ph-forgotPassword', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'link:forgot_your_password';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.ph-passwordSubmit', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'link:forget_password_submit';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.ph-signout', function() {
      if (philips && philips.analytics && typeof philips.analytics.trackNavNena === 'function') {
        philips.analytics.trackNavNena({
          navdest: 'sign_out',
          navid: 'header',
          navtype: 'nena'
        });
      }
    });

    $(document).on('click', '.ph-login', function() {
      ACC.omniture.bindTrackConversion('interaction', 'link:login');
    });

    $(document).on('click', '.ph-register', function() {
      ACC.omniture.bindTrackConversion('interaction', 'link:register');
    });

    $(document).on('click', '.ph-homepage__promotion--button', function() {
      ACC.omniture.bindTrackConversion('interaction', 'button:find_out_more');
    });

    $(document).on('click', '.ph-homepage__member--register', function() {
      ACC.omniture.bindTrackConversion('interaction', 'button:register');
    });

    $(document).on('click', '.ph-homepage__member--login', function() {
      ACC.omniture.bindTrackConversion('interaction', 'link:login_here');
    });
  },

  bindCartPage: function() {
    $(document).on('click', '.ph-download-button', function() {
      var url = $(this).attr('href');

      ACC.omniture.bindTrackConversion('download', 'excel');
      ACC.omniture.bindTrackConversion('download', url);
    });

    $(document).on('click', '.ph-edit_productquantity', function() {
      ACC.omniture.bindTrackConversion('interaction', 'link:edit_quantity');
    });

    $(document).on('change', '.ph-recurring-select', function() {
      var placeOrder = $(this).val();

      var description = 'select:' + placeOrder;

      ACC.omniture.bindTrackConversion('interaction', description);
    });

    $(document).on('click', '.ph-promocode-button', function() {
      ACC.omniture.bindTrackConversion('interaction', 'link:add_promo_code');
    });

    $(document).on('click', '.ph-continue-orange', function() {
      ACC.omniture.bindTrackConversion('interaction', 'button:checkout_bottom');
    });

    $(document).on('click', '.ph-continue-content', function() {
      ACC.omniture.bindTrackConversion('interaction', 'link:continue_shopping');
    });

    $(document).on('click', '.selectForCompare', function() {
      var productidvalue = $(this).attr('data-productid');

      var isSelected = '';

      if ($('.selectForCompare').is(':checked')) {
        isSelected = 'check';
      } else {
        isSelected = 'uncheck';
      }

      omnitureName = 'interaction';
      omnitureDescription = 'compare:' + productidvalue + ':' + isSelected;

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.compareAddToCartButton', function() {
      var addToCartNumber = $(this).attr('data-addToCartNumber'),
          compareAddToCartCodeId = '#productCodePost' + addToCartNumber,
          compareAddToCartCode = $(compareAddToCartCodeId).val();

      if (philips && philips.analytics && typeof philips.analytics.trackAjax === 'function') {
        philips.analytics.trackAjax({
          pagename: 'compare_products',
          events: 'scAdd,scOpen',
          products: compareAddToCartCode,
          type: 'o'
        });
      }
    });

    $(document).on('click', '#cart_content', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'mini_cart_view';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });
  },

  bindShopplistListPage: function() {
    $(document).on('click', '.ph-createshoppinglist', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'shopping_list:creation';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.ph-addrow', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'add_row';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.ph-removerow', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'delete_row';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.ph-openshoppinglist', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'shopping_list:open';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.ph-closeshoppinglist', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'shopping_list:close';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.submitRemoveProduct', function() {
      var productCode = $(this).attr('data-productcode');

      if (philips && philips.analytics && typeof philips.analytics.trackAjax === 'function') {
        philips.analytics.trackAjax({
          events: 'scRemove',
          products: productCode,
          type: 'o'
        });
      }
    });
    /* eslint-disable  sonarjs/no-identical-functions */
    $(document).on('click', '.createnewlist-btn', function() {
      /* eslint-enable  sonarjs/no-identical-functions */
      omnitureName = 'interaction';
      omnitureDescription = 'shopping_list:creation';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });
  },

  bindCategoryPage: function() {
    $(document).on('click', '.ph-refinement > li > a', function() {
      var filterName = $(this).text().trim().replace(/\s+/g, '_');
      var filterType = $(this).attr('data-refinementname');

      var check = '';

      if (filterName.length > 0) {
        check = 'check';
      } else {
        check = 'uncheck';
      }

      omnitureName = 'interaction';
      omnitureDescription = 'filter:' + filterType + ':' + filterName + ':' + check;

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.facet_block-label > input', function() {
      var filterName = $(this).parent().text().trim().replace(/\s+/g, '_');
      var filterType = $(this).attr('data-refinementname');

      var check = '';

      if ($('.facet_block-label > input').attr('checked')) {
        check = 'check';
      } else {
        check = 'uncheck';
      }

      omnitureName = 'interaction';
      omnitureDescription = 'filter:' + filterType + ':' + filterName + ':' + check;

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('change', '#sortOptions1', function() {
      var selectedOption = $('#sortOptions1 option:selected').text().trim().replace(/\s/g, '_');

      omnitureName = 'interaction';
      omnitureDescription = 'sort:' + selectedOption;

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.product-ctn', function() {
      var productidvalue = $(this).attr('data-productid');

      omnitureName = 'interaction';
      omnitureDescription = 'click:search_result:' + productidvalue;

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });
  },

  bindProductDetail: function() {
    $(document).on('click', '.ph-addshoppinglisttocart', function() {
      var prods = [];

      $('.ph-favproduct_ctn').each(function() {
        prods.push(';' + $(this).attr('data-ctn'));
      });

      if (philips && philips.analytics && typeof philips.analytics.trackAjax === 'function') {
        philips.analytics.trackAjax({
          events: 'scAdd,scOpen',
          products: prods.toString()
        });
      }
    });

    $(document).on('click', '.ph-removefavourite', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'remove_from_favorites:' + $(this).attr('data-productid');

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    if ($('.template-pages-CartPageTemplate').length > 0) {
      if ($('#globalMessages').find('.ph-orangebutton').length > 0 && $('.ph-voucherstatus').attr('data-voucherstatus') === 'true') {
        omnitureName = 'interaction';
        omnitureDescription = 'voucher:success';
      } else if ($('#globalMessages').find('.negative').length > 0 && location.pathname.split('/')[2] === 'applyVoucher') {
        omnitureName = 'interaction';
        omnitureDescription = 'voucher:error';
      }

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    }

    $(document).on('click', '.ph-taggingPdp', function() {
      if (philips && philips.analytics && typeof philips.analytics.trackAjax === 'function') {
        philips.analytics.trackAjax({
          events: 'scAdd,scOpen',
          products: productCtn,
          type: 'o'
        });
      }
    });
    $('.ph-pdptabs').click(function() {
      if (philips && philips.analytics && typeof philips.analytics.trackTab === 'function') {
        philips.analytics.trackTab('Product Details Tab Click');
      }
    });

    $('.ph-pdptabsecond').click(function() {
      if (philips && philips.analytics && typeof philips.analytics.trackTab === 'function') {
        philips.analytics.trackTab('Addidtional Info Tab Click');
      }
    });

    $('img.ph-displayimg').on('click', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'view_image:open';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.product-ctn', function() {
      var productid = $(this).attr('data-productid');

      omnitureName = 'interaction';
      omnitureDescription = 'click:search_result:' + productid;

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });


    $(document).on('click', '.ph-omniture-addtoshoppinglist', function() {
      var status = '';

      if ($(this).hasClass('shoppingListClicked')) {
        status = 'open';
      } else {
        status = 'close';
      }

      ACC.omniture.bindTrackConversion('interaction', 'add_to_shopping_list:' + status);
    });

    $(document).on('click', '.addtoshoppinglist > li > a', function() {
      var shoppingListName = $('.product-ctn').attr('data-productid');

      ACC.omniture.bindTrackConversion('interaction', 'add_to_shopping_list:' + shoppingListName);
    });
  },

  bindCheckOutPage: function() {
    $(document).on('click', '.ph-addressselect', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'payment_address';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });
    $(document).on('click', '.ph-deliveryaddress', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'delivery_address';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '#cancel-place-replenishmentOrder', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'click:schedule_replenishment:cancel';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $('#scheduleReplenishmentButton').click(function() {
      omnitureName = 'interaction';
      omnitureDescription = 'click:schedule_replenishment';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });
  },

  bindHomePage: function() {
    $(document).on('click', '.ph-navtagging .auto a', function() {
      if (philips && philips.analytics && typeof philips.analytics.trackNavNena === 'function') {
        philips.analytics.trackNavNena({
          navdest: $(this).text().split(' ').join('_'),
          navid: 'header',
          navtype: 'nena'
        });
      }
    });

    if ($('.template-pages-AccountPageTemplate').length > 0) {
      if (parseInt($('.prod_refine').attr('data-count'), 10) > 0) {
        omnitureName = 'interaction';
        omnitureDescription = 'search_order:success';
      } else if (parseInt($('.prod_refine').attr('data-count'), 10) === 0) {
        omnitureName = 'interaction';
        omnitureDescription = 'search_order:unsuccessfull';
      }

      if ($('.ph-searcherror').length > 0) {
        omnitureName = 'validation_error';
        omnitureDescription = $('.ph-searcherror').val();
      }

      if (omnitureName !== '' && omnitureDescription !== '') {
        ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
      }
    }

    $(document).on('click', '.ph-searchResultImg', function() {
      var productName = $(this).attr('data-productimg');

      omnitureName = 'interaction';
      omnitureDescription = 'click:search_result:' + productName;

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });
    $(document).on('click', '.ph-prodSearchName', function() {
      var productidvalue = $(this).attr('data-prod');

      omnitureName = 'interaction';
      omnitureDescription = 'click:search_result:' + productidvalue;

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.ph-myaccount', function() {
      if (philips && philips.analytics && typeof philips.analytics.trackNavNena === 'function') {
        philips.analytics.trackNavNena({
          navdest: 'my_account',
          navid: 'header',
          navtype: 'nena'
        });
      }
    });

    if ($('.headerContent').attr('data-attr') === 'true') {
      ACC.omniture.bindTrackConversion('user_login', 'user_login');
    }

    $(document).on('click', '.ph-homepage__topcategories--link', function() {
      var topCategoryName = $(this).find('.ph-homepage__topcategories--text').text();

      ACC.omniture.bindTrackConversion('interaction', 'link:' + topCategoryName);
    });
  },

  bindCartFlyout: function() {
    $(document).on('click', '#ph-cart_popup .ph-addtocart__checkout, #rollover_cart_popup .ph-minicart__checkout', function() {
      ACC.omniture.bindTrackConversion('interaction', 'button:check_out');
    });

    $(document).on('click', '#ph-cart_popup .ph-addtocart__viewcart, #rollover_cart_popup .ph-minicart__editcart', function() {
      ACC.omniture.bindTrackConversion('interaction', 'link:edit_cart');
    });

    $(document).on('click', '#ph-cart_popup #add_to_cart_close, #rollover_cart_popup .ph-minicart-close', function() {
      ACC.omniture.bindTrackConversion('interaction', 'close:shopping_cart_close');
    });
  },

  bindAnonymousShippingPage: function() {
    if ($('.ph-page-AnonymousCheckoutPage').length > 0) {
      $(document).on('click', '.ph-anonymous-checkout-flow input[id=ph-lumifyHaveAccountNo]', function() {
        ACC.omniture.bindTrackConversion('interaction', 'account_no:checkbox:checked');
      });

      $(document).on('click', '.ph-anonymous-checkout-flow input[id=ph-lumifyDontHaveAccountNo]', function() {
        ACC.omniture.bindTrackConversion('interaction', 'account_no:checkbox:unchecked');
      });

      $(document).on('click', '.ph-anonymous-checkout-flow input[id=radio1]', function() {
        ACC.omniture.bindTrackConversion('interaction', 'order_delivered:checkbox:single:checked');
      });

      $(document).on('click', '.ph-anonymous-checkout-flow input[id=radio2]', function() {
        ACC.omniture.bindTrackConversion('interaction', 'order_delivered:checkbox:multiple:checked');
      });

      $(document).on('click', '.ph-anonymous-checkout-flow input[id=ph-optinCheckbox]', function() {
        if ($(this).is(':checked')) {
          ACC.omniture.bindTrackConversion('interaction', 'communication:checkbox:checked');
        } else {
          ACC.omniture.bindTrackConversion('interaction', 'communication:checkbox:unchecked');
        }
      });

      ACC.omniture.subAnonymousShippingPage();
    }
  },

  subAnonymousShippingPage: function() {
    $(document).on('click', '.ph-anonymous-checkout-flow .ph-checkout_viewyourcart', function() {
      ACC.omniture.bindTrackConversion('interaction', 'link:view_your_cart');
    });

    $(document).on('change', '.ph-anonymous-checkout-flow #position', function() {
      var positionVal = $(this).val();

      ACC.omniture.bindTrackConversion('interaction', 'select:' + positionVal);
    });

    $(document).on('change', '.ph-anonymous-checkout-flow #organizationtype', function() {
      var organisationTypeVal = $.trim($(this).find('option:selected').text());

      ACC.omniture.bindTrackConversion('interaction', 'select:' + organisationTypeVal);
    });

    $(document).on('change', '.ph-anonymous-checkout-flow #region', function() {
      var stateVal = $(this).val();

      ACC.omniture.bindTrackConversion('interaction', stateVal);
    });

    $(document).on('click', '.ph-anonymous-checkout-flow .ph-shipping__backtocart', function() {
      ACC.omniture.bindTrackConversion('interaction', 'link:back_to_your_cart');
    });

    $(document).on('click', '.ph-anonymous-checkout-flow .ph-anonymousshipping__proceed', function() {
      ACC.omniture.bindTrackConversion('interaction', 'button:proceed_to_payment');
    });
  },

  bindFrequentlyOrderedProducts: function() {
    $(document).on('click', '.jcarousel-prev', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'click:frequently_viewed_products:carousel_left';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.jcarousel-next', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'click:frequently_viewed_products:carousel_right';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.ph-product-name', function() {
      var philipsCarouselCtn = $(this).attr('data-ctn');

      omnitureName = 'interaction';
      omnitureDescription = 'click:frequently_viewed_products:title:' + philipsCarouselCtn;

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.ph-prod-img', function() {
      var philipsCarouselCtn = $(this).attr('data-ctn');

      omnitureName = 'interaction';
      omnitureDescription = 'click:frequently_viewed_products:image:' + philipsCarouselCtn;

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.ph-addtocart', function() {
      var productcodeCtn = $(this).parents('.ph-addtocartform').attr('data-ctn');

      if (philips && philips.analytics && typeof philips.analytics.trackConversion === 'function') {
        philips.analytics.trackConversion({
          events: 'scOpen,scAdd',
          products: productcodeCtn,
          name: 'add_to_cart',
          type: 'o'
        });
      }
    });
  },

  bindAddToFav: function() {
    $(document).on('click', '.ph-addfavcart', function() {
      var productIds = [];

      $('.ph-favorites').each(function() {
        if ($(this).is(':checked')) {
          productIds.push(';' + $(this).attr('data-attr'));
        }
      });

      if (philips && philips.analytics && typeof philips.analytics.trackAjax === 'function') {
        philips.analytics.trackAjax({
          events: 'scAdd,scOpen',
          products: productIds.toString()
        });
      }
    });
  },

  bindFileUpdate: function() {
    $(document).on('click', '.ph-saveupdate', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'link:save_update';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.ph-choosefile', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'link:choose_file';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.ph-uploadfile', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'link:upload_file';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });
  },

  searchResultBannerimg: function() {
    var searchResult = $('.results > h1').attr('data-searchresult');

    $(document).on('click', '.template-pages-search-searchListPage .disp-img img', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'click:banner:' + searchResult;

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });
  },

  bindSearchOrder: function() {
    $(document).on('click', '#orderSearchSubmit', function() {
      ACC.omniture.bindTrackConversion('interaction', 'customer:search_order');
    });
    $(document).on('click', '.ph-orders-click', function() {
      ACC.omniture.bindTrackConversion('interaction', 'link:orders');
    });
  },

  bindHHSYouMayLike: function() {
    $(document).on('click', '.ph-hhsyoumaylikeimage', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'also_like:image';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.ph-hhsyoumaylikename', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'also_like:link';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.ph-hhsmoredetailslink', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'more_product_details';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.ph-hhsmoredetailsname', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'link';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.ph-hhsmoredetailsimage', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'image';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.simple_disp-img img', function() {
      var bannerTitles = $(this).attr('title');

      omnitureName = 'interaction';
      omnitureDescription = bannerTitles;

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.disp-img img', function() {
      var displayBannerTitles = $(this).attr('title');

      omnitureName = 'interaction';
      omnitureDescription = displayBannerTitles;

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });
  },

  bindPunchOut: function() {
    $(document).on('click', '.ph-punchout__canceltagging', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'cancel_requisition';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });

    $(document).on('click', '.ph-punchout__checkouttagging', function() {
      omnitureName = 'interaction';
      omnitureDescription = 'button:checkout';

      ACC.omniture.bindTrackConversion(omnitureName, omnitureDescription);
    });
  },

  bindDecisionTag: function() {
    $('.ph-decision-page__specialwrap').on('click', function() {
      var ctn = $(this).attr('data-productid');

      ACC.omniture.bindTrackConversion('prodview', ctn);
    });
  },

  bindQtyTag: function(qtyInput) {
    var loadVal = '';

    $('.' + qtyInput + ' > input').on('focus', function() {
      loadVal = $(this).val();
    });

    $('.' + qtyInput + ' > input').keyup($.debounce(700, false, function() {
      var ctn = $(this).attr('data-productid'),
          quantity = $(this).val(),
          fluctuation = '';

      if (quantity > loadVal) {
        fluctuation = 'increase';
      } else {
        fluctuation = 'decrease';
      }

      if (quantity !== loadVal) {
        var description = ctn + ':' + quantity + ':' + fluctuation;

        ACC.omniture.bindTrackConversion('interaction', description);
      }
    }));
  },

  bindDecisionDeleteTag: function() {
    $('.submitRemoveProduct').on('click', function() {
      var ctn = $(this).attr('data-productcode');

      if (philips && philips.analytics && typeof philips.analytics.trackAjax === 'function') {
        philips.analytics.trackAjax({
          events: 'scRemove',
          products: ctn,
          type: 'o'
        });
      }
    });
  },

  bindPaymentPage: function() {
    $(document).on('click', '.ph-checkout_yourorder_paymentmain .ph-checkout_viewyourcart', function() {
      ACC.omniture.bindTrackConversion('interaction', 'link:view_your_cart');
    });

    $(document).on('click', '.radiobuttons_paymentselection input[id=PaymentTypeSelection_ACCOUNT]', function() {
      ACC.omniture.bindTrackConversion('interaction', 'account_payment:checkbox:checked');
    });

    $(document).on('click', '.radiobuttons_paymentselection input[id=PaymentTypeSelection_CARD]', function() {
      ACC.omniture.bindTrackConversion('interaction', 'card_payment:checkbox:checked');
    });

    $(document).on('click', '.ph-termslabel input[id=lumifyAddendum1]', function() {
      if ($(this).is(':checked')) {
        ACC.omniture.bindTrackConversion('interaction', 'addendum:checkbox:checked');
      } else {
        ACC.omniture.bindTrackConversion('interaction', 'addendum:checkbox:unchecked');
      }
    });

    $(document).on('click', '.ph-termslabel input[id=Terms1]', function() {
      if ($(this).is(':checked')) {
        ACC.omniture.bindTrackConversion('interaction', 'terms_conditions:checkbox:checked');
      } else {
        ACC.omniture.bindTrackConversion('interaction', 'terms_conditions:checkbox:unchecked');
      }
    });

    $(document).on('click', '.ph-lumifyparent__diffbilling input[id=add_different_billing]', function() {
      if ($(this).is(':checked')) {
        ACC.omniture.bindTrackConversion('interaction', 'billing_address_different:checkbox:checked');
      } else {
        ACC.omniture.bindTrackConversion('interaction', 'billing_address_different:checkbox:unchecked');
      }
    });


    $(document).on('click', '#checkout_summary_accountpayment_div, #ph-lumifyparent__submit, #ph-paymentpaynow', function() {
      ACC.omniture.bindTrackConversion('interaction', 'button:submit_payment');
    });
  },

  bindPageFunctions: function() {
    ACC.omniture.bindRegistrationPage();
    ACC.omniture.bindLoginPage();
    ACC.omniture.bindCartPage();
    ACC.omniture.bindShopplistListPage();
    ACC.omniture.bindHomePage();
    ACC.omniture.bindCartFlyout();
    ACC.omniture.bindAnonymousShippingPage();
    ACC.omniture.bindProductDetail();
    ACC.omniture.bindCategoryPage();
    ACC.omniture.bindCheckOutPage();
    ACC.omniture.bindPaymentPage();
  },

  bindOtherFunctions: function() {
    ACC.omniture.bindFrequentlyOrderedProducts();
    ACC.omniture.bindAddToFav();
    ACC.omniture.bindFileUpdate();
    ACC.omniture.searchResultBannerimg();
    ACC.omniture.bindSearchOrder();
    ACC.omniture.bindHHSYouMayLike();
    ACC.omniture.bindPunchOut();
    ACC.omniture.bindDecisionTag();
    ACC.omniture.bindQtyTag('ph-qtylabeltext');
    ACC.omniture.bindQtyTag('ph-qtydet__block__thrd--input');
    ACC.omniture.bindDecisionDeleteTag();
  },
  checkoutPageEvents: function() {
    $(document).on('click', '.ph-backcheckoutlink', function() {
      window.gaclkFn.gaButtonClicks({
        elementClass: '',
        triggerType: 'button',
        sectionValue: 'backto_shipping',
        linkValue: ''
      });
    });
    $(document).on('click', '.ph-shipping__backtocart', function() {
      window.gaclkFn.gaButtonClicks({
        elementClass: '',
        triggerType: 'button',
        sectionValue: 'backto_cart',
        linkValue: ''
      });
    });
  },
  commonGaTagging: function() {
    if ($('li.ph-support-item > a').length > 0) {
      window.gaclkFn.linksOnclickGaEvent('li.ph-support-item > a', 'footer_support');
    }

    if ($('li.ph-quicklinks > a').length > 0) {
      window.gaclkFn.linksOnclickGaEvent('li.ph-quicklinks > a', 'quick_links');
    }

    if ($('.ph-footer__cookies').length > 0) {
      $('.ph-footer__cookies li a').on('click', function() {
        var sectionVal = 'footer_link';

        if ($(this).text().includes('Contact')) {
          sectionVal = 'footer_contactUs';
        }

        if ($(this).text().includes('Privacy')) {
          sectionVal = 'footer_privacy';
        }

        if ($(this).text().includes('Cookie')) {
          sectionVal = 'footer_cookieNotice';
        }

        window.gaclkFn.gaButtonClicks({
          elementClass: '',
          triggerType: 'link',
          sectionValue: sectionVal,
          linkValue: ''
        });
      });
    }

    if ($('.importdownloadbutton').length > 0) {
      $(document).on('click', '.importdownloadbutton', function() {
        ACC.omniture.bindTrackConversion('interaction', 'button:download');
      });
    }
  }
};

$(document).ready(function() {
  ACC.omniture.bindPageFunctions();
  ACC.omniture.bindOtherFunctions();

  if (window.gaclkFn) {
    ACC.omniture.checkoutPageEvents();
    ACC.omniture.commonGaTagging();
  }
});
